import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=6afd67f8&"
import script from "./Diagnostic.vue?vue&type=script&lang=js&"
export * from "./Diagnostic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports